export const BaseUrl = "https://api.mobilityinfotechlogistics.com";
